module.exports = __webpack_public_path__ + "img/Instagram.2fc63a3e.svg";